if (!customElements.get('everyday-jewelry-carousel')) {
  customElements.define('everyday-jewelry-carousel', class extends HTMLElement {
    connectedCallback() {
      const track = this.querySelector('.gp-grid');
      if (!track) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const move = (direction) => {
        const panel = track.querySelector('.gp-panel');
        if (!panel) return;
        track.scrollBy({left: direction * (panel.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).gap) || 0)), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      track.addEventListener('keydown', (event) => {
        if (event.target !== track) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault(); move(event.key === 'ArrowLeft' ? -1 : 1);
        }
      }, options);
      track.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        this.start = event.clientX; this.dragged = false;
      }, options);
      window.addEventListener('pointerup', (event) => {
        if (this.start == null) return;
        const delta = event.clientX - this.start;
        if (Math.abs(delta) > 40) { this.dragged = true; move(delta < 0 ? 1 : -1); }
        this.start = null;
      }, options);
      track.addEventListener('dragstart', (event) => event.preventDefault(), options);
      track.addEventListener('click', (event) => {
        if (this.dragged) { event.preventDefault(); this.dragged = false; }
      }, { ...options, capture: true });
      document.addEventListener('shopify:block:select', (event) => {
        const panel = event.target.closest('.gp-panel');
        if (!panel || !track.contains(panel)) return;
        track.scrollTo({ left: panel.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }, options);
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
